import React, { useState, useEffect } from 'react';
import { Table, Input, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import './index.css';

const Blacklist = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({ q: '' });
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const loadData = async (page = pagination.current, pageSize = pagination.pageSize, qOverride = filters.q) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        message.error('未登录或凭证已失效');
        setList([]);
        setPagination(p => ({ ...p, total: 0 }));
        return;
      }

      const res = await axios.get('/api/blacklist', {
        params: { page, per_page: pageSize, q: qOverride?.trim() || undefined },
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      const total = Array.isArray(res.data) ? data.length : res.data?.total || 0;
      setList(data);
      setPagination(prev => ({ ...prev, current: page, pageSize, total }));
    } catch (e) {
      message.error('获取数据失败');
      setList([]);
      setPagination(p => ({ ...p, total: 0 }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData(1, 10, filters.q); // 挂载仅一次分页查询
  }, []);

    const columns = [
    { title: '防伪码', dataIndex: 'anti_cheat_code', key: 'anti_cheat_code' },
    { title: '店铺名称', dataIndex: 'shop_name', key: 'shop_name', width: 120 },
    { title: '查证人', dataIndex: 'checked_person', key: 'checked_person', width: 120 },
    { title: '机器码', dataIndex: 'machine_code', key: 'machine_code', ellipsis: true },
    { title: '微信号', dataIndex: 'wechat_id', key: 'wechat_id', width: 160 },
    { title: '添加时间', dataIndex: 'created_at', key: 'created_at', width: 180, render: v => (v ? new Date(v).toLocaleString() : '-') },
    { title: '原因', dataIndex: 'remarks', key: 'result', width: 240, }
  ];

  return (
    <div className="blacklist-container">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Input.Search
          style={{ width: 320 }}
          placeholder="按 防伪码/店铺ID/机器码/微信号/原因 模糊搜索"
          value={filters.q}
          allowClear
          enterButton={<SearchOutlined />}
          onChange={({ target: { value } }) => {
            setFilters(prev => ({ ...prev, q: value }));
            if (value === '') {
              setPagination(p => ({ ...p, current: 1 }));
              loadData(1, pagination.pageSize, '');
            }
          }}
          onSearch={() => {
            setPagination(p => ({ ...p, current: 1 }));
            loadData(1, pagination.pageSize, filters.q);
          }}
        />

      </div>

      <div className="table-container">
        <Table
          columns={columns}
          dataSource={list}
          rowKey="id"
          loading={loading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (t) => `共 ${t} 条记录`,
            onChange: (p, ps) => {
              setPagination(prev => ({ ...prev, current: p, pageSize: ps }));
              loadData(p, ps, filters.q);
            },
          }}
        />
      </div>

    </div>
  );
};

export default Blacklist;